import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { concatAndDeDuplicateObjects } from '@/lib/utils';

interface NoteItem {
  id: string;
  [key: string]: any;
}

interface NotesState {
  items: NoteItem[];
  loading: boolean;
  error: string | null;
}

const initialState: NotesState = {
  items: [],
  loading: false,
  error: null,
};

const notesSlice = createSlice({
  name: 'notes',
  initialState,
  reducers: {
    // Action creators for Redux Offline
    submitNote: (state, action: PayloadAction<NoteItem>) => {
      state.items = [action.payload, ...state.items];
    },
    submitNoteCommit: (state) => {
      // Handle success if needed
    },
    submitNoteFailed: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },

    loadMoreNotes: (state, action: PayloadAction<{
      job_id: string;
      page: number;
    }>) => {
      state.loading = true;
      state.error = null;
    },
    loadMoreNotesCommit: (state, action: PayloadAction<NoteItem[]>) => {
      state.loading = false;
      state.items = [...state.items, ...action.payload];
    },
    loadMoreNotesFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Handle data from GET_BOOKINGS_COMMIT
    builder.addCase('GET_BOOKINGS_COMMIT', (state, action: PayloadAction<{
      notes?: NoteItem[];
      bookings?: any[];
      [key: string]: any;
    }>) => {
      const { notes } = action.payload;
      const { meta } = action as any;

      const isPagedRequest = meta && meta.page !== undefined && meta.page > 0;

      if (isPagedRequest) {
        if (notes && notes.length > 0) {
          state.items = concatAndDeDuplicateObjects('id', state.items, notes);
        }
      } else {
        // First page load or refresh - replace all notes
        state.items = notes || [];
      }
    });
  },
});

export const {
  submitNote,
  submitNoteCommit,
  submitNoteFailed,
  loadMoreNotes,
  loadMoreNotesCommit,
  loadMoreNotesFailed,
} = notesSlice.actions;

export default notesSlice.reducer;